module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.tolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "button button-link button-nav pull-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "3rem"
    }
  }, [(_vm.VipPlanList.manageCustomerPlans && _vm.VipPlanList.manageCustomerPlans.length > 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "larger"
    }
  }, [_vm._v("我管理的大客户计划")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.VipPlanList.manageCustomerPlans), function(plan) {
    return _c('div', {
      staticClass: "list-block cards-list",
      staticStyle: {
        "margin-top": "30px"
      }
    }, [_c('ul', {
      on: {
        "click": function($event) {
          return _vm.gotovipdetails(plan)
        }
      }
    }, [_c('li', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("名称- " + _vm._s(plan.customerPlanName))]), _vm._v(" "), _c('span', [_vm._v("类型- "), (plan.type === 2) ? _c('span', [_vm._v("\n              储值账户\n            ")]) : _c('span', [_vm._v("\n              VIP账户\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-content-inner",
      staticStyle: {
        "margin-bottom": "25px"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n                  等级-- VIP" + _vm._s(plan.VIPLevel) + "\n                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("\n                  单位-- " + _vm._s(plan.enterpriseName) + "\n                ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("\n              生效时间- " + _vm._s(plan.startDt) + "\n            ")]), _vm._v(" "), _c('span', [_vm._v("\n             有效截止时间- " + _vm._s(plan.validDt) + "\n            ")])])])])])
  }), _vm._v(" "), (_vm.VipPlanList.ubietyCustomerPlans && _vm.VipPlanList.ubietyCustomerPlans.length > 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "larger"
    }
  }, [_vm._v("我所属的大客户计划\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.VipPlanList.ubietyCustomerPlans), function(plan) {
    return _c('div', {
      staticClass: "list-block cards-list",
      staticStyle: {
        "margin-top": "30px"
      }
    }, [_c('ul', [_c('li', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("名称- " + _vm._s(plan.customerPlanName))]), _vm._v(" "), _c('span', [_vm._v("类型- "), (plan.type === 2) ? _c('span', [_vm._v("\n              储值账户\n            ")]) : _c('span', [_vm._v("\n              VIP账户\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-content-inner",
      staticStyle: {
        "margin-bottom": "25px"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n                  等级-- VIP" + _vm._s(plan.VIPLevel) + "\n                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("\n                  单位-- " + _vm._s(plan.enterpriseName) + "\n                ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("\n              生效时间- " + _vm._s(plan.startDt) + "\n            ")]), _vm._v(" "), _c('span', [_vm._v("\n             有效截止时间- " + _vm._s(plan.validDt) + "\n            ")])])])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3836c7e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyVipPlan/VipPlanDetails.vue
// module id = 1601
// module chunks = 8